import { Children, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { BUTTON_COLORS } from "@miplatform/constants";
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
import { Box, List, ListItem } from "@mui/material";
import { MiButton } from "../MiButton/MiButton";

export function MiShowMoreList({
  children,
  enableShowMore,
  enableCount,
  showMoreLimit,
  disabled = false,
  listContainerStyle = null,
  maxHeight = 300,
}) {
  const { classes } = useStyles({ maxHeight, disabled });
  const [showMore, setShowMore] = useState(false);

  const data = Children.toArray(children);
  const showMoreEnabled = data.length > showMoreLimit && enableShowMore;
  const itemLimit = showMoreEnabled ? showMoreLimit : data.length;
  const hiddenCount =
    showMoreEnabled && enableCount ? data.length - showMoreLimit : 0;
  const getBtnTitle = () => {
    let title = showMore ? "Collapse" : "Show More";
    title += !showMore && hiddenCount > 0 ? ` (${hiddenCount})` : "";

    return title;
  };

  return (
    <Box className={classes.root}>
      <List
        className={listContainerStyle ?? classes.listContainer}
        data-testid="show-more-list"
      >
        {data.slice(0, itemLimit).map((item) => (
          <ListItem className={classes.listItem} key={item.key ?? ""}>
            {item}
          </ListItem>
        ))}
        {showMore &&
          data.slice(itemLimit).map((item) => (
            <ListItem className={classes.listItem} key={item.key ?? ""}>
              {item}
            </ListItem>
          ))}
      </List>
      {showMoreEnabled && (
        <MiButton
          title={getBtnTitle()}
          variant="contained"
          size="small"
          color={BUTTON_COLORS.GREY}
          fullWidth
          startIcon={{
            path: showMore ? mdiChevronUp : mdiChevronDown,
          }}
          className={classes.btn}
          onClick={() => setShowMore(!showMore)}
          disabled={disabled}
          data-testid="show-more-list-button"
        />
      )}
    </Box>
  );
}

const useStyles = makeStyles()((theme, { maxHeight }) => ({
  root: {
    height: "100%",
    overflow: "auto",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    paddingTop: 0,
    paddingBottom: 0,
    maxHeight: maxHeight || 300,
    overflow: "auto",
    borderRadius: theme.spacing(2),
  },
  listItem: {
    display: "block",
    padding: 0,
    width: "100%",
  },
  btn: {
    position: "sticky",
    bottom: 0,
    marginTop: 8,
  },
}));
